import { CONTENT_ONLY, PREVIEW, TEXT_FIELD_MATRIX } from './printingModes';
import { EDIT, WIZARD } from './interactionModes';

export * from './common';

export const PRINTING_MODE = { CONTENT_ONLY, PREVIEW, TEXT_FIELD_MATRIX };
export const INTERACTION_MODE = { EDIT, WIZARD };

export const ARIAL_FONT = 'Arial';
export const LIBERATION_SANS_FONT = 'Liberation Sans';
export const LIBERATION_SERIF_FONT = 'Liberation Serif';
export const LIBERATION_MONO_FONT = 'Liberation Mono';

export const fontsList = [ARIAL_FONT, LIBERATION_SANS_FONT, LIBERATION_SERIF_FONT, LIBERATION_MONO_FONT];
